import Vue from "vue";
import Index from "./index.vue";

import Vuetify from "vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/dist/vuetify.min.css";

import VModal from "vue-js-modal";

import Foo from "./foo";
import Foo2 from "./foo2";
import Bar from "./bar";

import Home from "./Home";
import Magazine from "./magazine";
import Store from "./store";
import Locations from "./locations";

import VueRouter from "vue-router";

import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBd2q_j6RR7vDwGp-6oFmZj2JUoruC97fM",
  authDomain: "jido-button.firebaseapp.com",
  projectId: "jido-button",
  storageBucket: "jido-button.appspot.com",
  messagingSenderId: "1094443221312",
  appId: "1:1094443221312:web:3b1f108b26617bf6fcfaa5",
  measurementId: "G-9BDBHK73WD",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();

Vue.use(VueRouter);
Vue.use(Vuetify);
Vue.use(VModal);

// Vue routers
const routes = [
  { path: "/home", component: Home },
  { path: "/store", component: Store },
  { path: "/magazine", component: Magazine },

  { path: "/foo", component: Foo } /* 백오피스 (게시물 수정) */,
  { path: "/foo2", component: Foo2 } /* 지역별 썸네일 설정 */,
  { path: "/bar", component: Bar } /* (임시) (새로운 게시물 추가) */,
  { path: "/locations", component: Locations },
  { path: "/locations/:id", component: Locations },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

Vue.config.productionTip = false;

new Vue({
  vuetify: new Vuetify({
    icons: {
      iconfont: "md",
    },
  }),
  render: (h) => h(Index),
  router,
}).$mount("#app");
